// extracted by mini-css-extract-plugin
export var active = "Footer-module--active--f77e0";
export var activeLink = "Footer-module--activeLink--4ff2d";
export var aloneLink = "Footer-module--aloneLink--3f9d9";
export var bg = "Footer-module--bg--69a6d";
export var companyLinks = "Footer-module--companyLinks--53598";
export var containerLine = "Footer-module--containerLine--26b15";
export var containerLineContacts = "Footer-module--containerLineContacts--75bdd";
export var credential = "Footer-module--credential--37ae2";
export var divider = "Footer-module--divider--25c90";
export var footer = "Footer-module--footer--d9f4c";
export var footerMain = "Footer-module--footerMain--8d509";
export var legalContainer = "Footer-module--legalContainer--6b0d4";
export var link = "Footer-module--link--3a930";
export var linkWrapper = "Footer-module--linkWrapper--bb462";
export var phoneContainer = "Footer-module--phoneContainer--4d2d1";
export var wrapper = "Footer-module--wrapper--a1713";
export var wrapperMain = "Footer-module--wrapperMain--be5f0";